/* eslint-env browser, jquery */
(function() {
    window.App.onReady(function() {
        var $userAddress = $('#user-address');
        $userAddress.find('textarea').on('change keyup', function() {
            var $button = $(this).parents('form').find('button');
            if ($(this).val().length == 0) {
                $button.attr('disabled', 'disabled');
            } else {
                $button.removeAttr('disabled');
            }
        }).end().find('form').on('submit', function() {
            $(this).find('button').attr('disabled', 'disabled');
        });

        $('.user-address__edit').on('click', function() {
            $('.user-address__form-tr').hide();
            $(this).parents('tr').next().show();
            return false;
        });
    });
})();
